import React, { useEffect } from 'react'
import ContactUs from '../Main/ContactUs'
import Intro from './Intro'
import './AcademyPage.css'
import Clients from './Clients'
import Problems from './Problems'
import Config from './Config'
import Platform from './Platform'
import Modules from './Modules'
import Payment from './Payment'

const AcademyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <Intro />
      <Clients />
      <Problems />
      <Config />
      <Platform />
      <Modules />
      <Payment />
      <ContactUs />
    </>
  )
}

export default AcademyPage
